import { createSetState, createStore } from '@flowus/common/zustand/utils';
import type { OtherSpacePublicStateType } from './type';

export const $otherSpaceState = createStore<OtherSpacePublicStateType>(() => ({}));

export const $setOtherSpaceState = createSetState($otherSpaceState);
